import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

const useStyles = makeStyles(() => ({
  root: {
    color: '#335267',
    padding: '0px 30px',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    fontSize: '13px',
    minWidth: '84px!important'
  },

  wrapper: { alignItems: 'flex-start' },
  selected: { backgroundColor: '#E2F5F8', fontWeight: 'bold' },
  textColorInherit: { opacity: 1, color: '#335267' }
}));

export const ToolbarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 540px;
  @media (max-width: 600px) {
    flex-direction: column;
    min-width: 100%;
  }
`;


export default useStyles;
